import { ROUTE_PATH } from "@/common/constants/routing";
import { AppPermission, UserDto, UserReferenceDto } from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import UserInline, { UserInlineProps } from "./UserInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity: UserDto | UserReferenceDto | null | undefined;
  entityId?: string | null;
  inlineProps?: Partial<UserInlineProps>;
}

export default function UserLink({ entity, entityId, inlineProps, ...otherProps }: Props) {
  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.FleetAppAccess, AppPermission.TenantUserRead]}
      to={ROUTE_PATH.USER_VIEW(entity?.id || entityId || "")}
      content={<UserInline entity={entity} entityId={entityId} {...inlineProps} />}
      {...otherProps}
    />
  );
}
